export default "/images/light-mode-multi-ppv.png?ce10db3283d83c85c9ee38619cb62d42";